import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ApprovalFlowScenario  {
    _originalTypeClassName = "zERP.BO.ApprovalFlowScenario";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ApprovalFlowScenario.translate = translateService;
}
this.Steps = [];
this.Id = null;
this.DepartmentLevel = null;
this.Score = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DepartmentLevel:any;
Score:any;
ApprovalFlow:any;
Steps:any;
Department:any;
DepartmentCategory:any;
static setApprovalFlow = ($this, value) => {
var oldValue = $this.ApprovalFlow;
$this.ApprovalFlow = value;
if (value != null) {
if (oldValue != null) {
Domain.ApprovalFlow.removeScenarios(oldValue, $this);
}
Domain.ApprovalFlow.addScenarios(value, $this);
}
}
static setSteps = ($this, items) => {
                if (items == null) items = [];
                if ($this.Steps == null) $this.Steps = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Steps.length > 0) {
                    Domain.ApprovalFlowScenario.removeSteps($this, $this.Steps[0]);
                }

                Domain.ApprovalFlowScenario.addManySteps($this, copyItems);
            }
static addManySteps = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ApprovalFlowScenario.addSteps($this, items[i]);
                }
            }
static addSteps = ($this, item) => {
                if ($this.Steps == null) $this.Steps = [];
                if (item == null || $this.Steps.indexOf(item) > -1) return;
                $this.Steps.push(item);
if (item.Scenario != $this) {
Domain.ApprovalFlowStep.setScenario(item, $this);
}
}
static addRangeSteps = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ApprovalFlowScenario.addSteps($this, item));
            }
static removeSteps = ($this, item) => {
                if ($this == null || $this.Steps == null || $this.Steps.indexOf(item) === -1) return;
                var _index = $this.Steps.indexOf(item);
                $this.Steps.splice(_index, 1);
item.Scenario = null;
}
static clearSteps = ($this) => { $this.Steps = null; }
static setDepartment = ($this, value) => {
var oldValue = $this.Department;
$this.Department = value;
if (value != null) {
}
}
static setDepartmentCategory = ($this, value) => {
var oldValue = $this.DepartmentCategory;
$this.DepartmentCategory = value;
if (value != null) {
}
}

static FixOrdering($this: any): any{let index = 1;
for (let _istep = 0; _istep < ($this?.Steps?.linq?.orderBy((s) => s?.Index)?.toArray() == null ? 0 : $this?.Steps?.linq?.orderBy((s) => s?.Index)?.toArray().length); _istep++) {let step = $this?.Steps?.linq?.orderBy((s) => s?.Index)?.toArray()[_istep];step.Index = index;index = Joove.Common.safeNumber(index) + Joove.Common.safeNumber(1);}
let score = 0;
if (CLMS.Framework.Number.GreaterThanOrEqual(() => $this.DepartmentLevel, () => 0)) {score = Joove.Common.safeNumber(score) + Joove.Common.safeNumber(1);}
if ($this?.Department != null) {score = Joove.Common.safeNumber(score) + Joove.Common.safeNumber(1);}
if ($this?.DepartmentCategory != null) {score = Joove.Common.safeNumber(score) + Joove.Common.safeNumber(1);}
$this.Score = score;
}
static IsMatch($this: any, department: any): any{if (CLMS.Framework.Number.NotEqual(() => $this.DepartmentLevel, () => null) && CLMS.Framework.Number.GreaterThanOrEqual(() => $this.DepartmentLevel, () => 0) && CLMS.Framework.Number.NotEqual(() => department.Level, () => $this.DepartmentLevel)) {console.warn("Failed due to level " + Joove.Common.safeNumber($this?.DepartmentLevel) + " vs " + Joove.Common.safeNumber(department?.Level));return false;}
if ($this?.Department != null && $this?.Department != department) {console.warn("Failed due to Department " + Joove.Common.safeNumber($this?.Department?.Id) + " vs " + Joove.Common.safeNumber(department?.Id));return false;}
if ($this?.DepartmentCategory != null && department?.DepartmentCategory != $this?.DepartmentCategory) {console.warn("Failed due to DepartmentCategory " + Joove.Common.safeNumber($this?.DepartmentCategory?.Id) + " vs " + Joove.Common.safeNumber(department?.DepartmentCategory?.Id));return false;}
return true;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}